import React, { useCallback } from 'react'
import { InternalLink } from '@/atoms/InternalLink'
import { CaptionSM, EyebrowSM } from '@/atoms/Text'
import { FeaturePrompt, FeaturePromptProps } from '@/molecules/FeaturePrompts'
import { useAngelPlayerContext } from '@/organisms/AngelPlayer'
import { useCollectiblesPlayer } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerContext'
import { ReactFCC } from '@/types/react'
import { useSafeTrack } from '@/utils/analytics'
import { useLoginUrl } from '@/utils/auth-utils'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const FeatureLoginPrompt: ReactFCC<FeaturePromptProps> = ({ featureName, show }) => {
  const { t } = useTranslate('watch')
  const { getCurrentMoment } = useCollectiblesPlayer()
  const { asset, controller } = useAngelPlayerContext()
  const track = useSafeTrack()

  const { loginUrl } = useLoginUrl()

  const handleOnClick = useCallback(() => {
    track('Login To Favorite A Scene Clicked', {
      momentId: getCurrentMoment?.()?.id,
      projectSlug: asset.projectSlug,
      playerTime: controller.getCurrentTime(),
      context: 'Reaction Button Prompt',
    })
  }, [asset.projectSlug, controller, getCurrentMoment, track])

  return (
    <FeaturePrompt featureName={featureName} promptName="Login Require Prompt" show={show}>
      <div className="flex w-full max-w-[350px] flex-col space-y-1.5 rounded-lg bg-gray-800 p-2 md:whitespace-nowrap">
        <div className="flex justify-between">
          <EyebrowSM>
            <Translate t={t} i18nKey="loginRequired">
              Login Required
            </Translate>
          </EyebrowSM>
        </div>
        <CaptionSM color="gray-300">
          <Translate t={t} i18nKey="toLoveAScenePleaseUseAnAccount">
            To love a scene, please{' '}
            <InternalLink onClick={handleOnClick} className="text-oxide-bright underline" href={loginUrl}>
              login
            </InternalLink>
          </Translate>
        </CaptionSM>
      </div>
    </FeaturePrompt>
  )
}
